import { Request, XHRBackend, BrowserXhr, ResponseOptions, XSRFStrategy, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Injectable } from '@angular/core';
import { TokenService } from './token.service';
import { Router } from '@angular/router';
declare var jQuery: any;

// sweet global way to handle 401s - works in tandem with existing AuthGuard route checks
// http://stackoverflow.com/questions/34934009/handling-401s-globally-with-angular-2
@Injectable()
export class AuthenticateXHRBackend extends XHRBackend {

    constructor(_browserXhr: BrowserXhr, _baseResponseOptions: ResponseOptions, _xsrfStrategy: XSRFStrategy, private router: Router) {
        super(_browserXhr, _baseResponseOptions, _xsrfStrategy);
    }

    createConnection(request: Request) {
      let xhrConnection = super.createConnection(request);
      xhrConnection.response = xhrConnection.response.catch((error: Response) => {
          if ((error.status === 401 || error.status === 403) && (window.location.href.match(/\?/g) || []).length < 2) {
              console.log('The authentication session expired or the user is not authorized. Force refresh of the current page.');
              this.router.navigate(['/login']);
              this.showMessage('Session Expired', '0', 'The authentication session expired or the user is not authorized. Force refresh of the current page.');
              TokenService.removeToken();

              // Return an empty Observable or a specific value
              return Observable.empty(); // or return Observable.of(someValue);
          }
          return Observable.throw(error);
      });
      return xhrConnection;
    }


    truncateString(str, num) {
      if(str!=null){
        return str.length > num ? str.slice(0, num) + '...' : str;
      } else {
        return ''
      }
    }

    showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
      let truncatedAdditionalInfo = this.truncateString(additionalInfo, 1000);
      jQuery('#PopupMessageTitle').html(title);
      jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (truncatedAdditionalInfo ? ' -- ' + truncatedAdditionalInfo : ''));
      jQuery('#PopupMessage').modal('show');
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/base/security/authenticate-xhr.backend.ts